import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetEventsRoutePath } from '#/modules/search/events/routing/searchGetEventsRoutePath';

import type { ParticipateDropdownData } from './types/ParticipateDropdownData';

export const participateDropdownDataPt: ParticipateDropdownData = {
  search: {
    title: 'Participar',
    items: [
      {
        type: 'participate',
        title: 'Blog Idealista',
        href: '/pt/blog?pq=',
      },
      {
        type: 'post-event',
        title: 'Publicar Evento',
        href: '/en/volunteering-resources?pq=',
      },
      {
        type: 'event',
        title: 'Buscar Evento',
        href: searchGetEventsRoutePath({ locale: I18nLocale.PT }),
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [
      {
        type: 'points',
        title: 'Pontos Idealistas',
        description:
          'O espaço do bairro que convida as pessoas a imaginar, conectar e agir por um mundo melhor.',
        href: '/pt/pontos-idealistas',
      },
      {
        type: 'recipe-for-action',
        title: 'Receitas para Ação',
        description: 'Boas ideias para fazer do mundo um lugar melhor.',
        href: '/csr-services',
      },
    ],
  },
};
